import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import Blog1 from "../Assets/blog1.jpg"
import Blog2 from "../Assets/blog2.jpg"
import Blog3 from "../Assets/blog3.jpg"
import Blog4 from "../Assets/blog4.webp"

const blogs = [
  {
    title: "The Future of Smart Automation",
    description: "JCS Global is at the forefront of revolutionizing automation with innovative IoT solutions, making smart automation more efficient and accessible than ever before.",
    image: Blog1,
  },
  {
    title: "Ensuring Secure Transactions with JCSPay",
    description: "Security and seamless transactions go hand-in-hand with JCSPay, providing top-tier encryption and fraud detection mechanisms to safeguard your finances.",
    image: Blog2,
  },
  {
    title: "Innovations in IoT for Home Security",
    description: "JCS Global’s advanced IoT security systems are redefining safety, offering AI-driven surveillance, remote monitoring, and smart automation for your home.",
    image: Blog3,
  },
  {
    title: "How AI is Transforming Call Centers",
    description: "Artificial Intelligence is revolutionizing customer service, providing instant responses, predictive analytics, and efficient call center automation.",
    image: Blog4,
  },
];

const categories = ["IoT Solutions", "Automation", "Cyber Security", "AI & Machine Learning", "Smart Homes"];

export default function Blog() {
  return (
    <div>
      <Fixed />
      <div className="min-h-screen bg-gray-900 text-white pt-32 px-6">
        {/* Hero Section */}
        <motion.div 
          className="text-center max-w-4xl mx-auto mb-12"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-5xl font-bold text-amber-500">JCS Global Blog</h1>
          <p className="text-lg text-gray-400 mt-4">
            Explore insights on smart automation, IoT security, AI advancements, and more.
          </p>
        </motion.div>

        {/* Featured Blog Section */}
        <div className="bg-amber-600 p-8 rounded-lg shadow-lg max-w-6xl mx-auto mb-12 text-center">
          <h2 className="text-3xl font-semibold">Featured Insight</h2>
          <p className="text-gray-200 mt-2">The latest and most impactful article from JCS Global.</p>
          <motion.div 
            className="bg-amber-600 text-white p-8 rounded-lg shadow-md mt-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <p className="text-lg">
              JCS Global is a leader in **smart automation, IoT solutions, AI-driven security, and digital payment systems**. 
              Our mission is to revolutionize industries by integrating cutting-edge technology that enhances efficiency, security, 
              and convenience. Whether it's **intelligent home automation, AI-powered call centers, or secure financial transactions**, 
              JCS Global ensures seamless innovation for a smarter future.
            </p>
            <p className="text-lg mt-4">
              Explore how our **IoT solutions** can optimize your business, how **AI transforms customer interactions**, and 
              how **JCSPay secures financial transactions**. At JCS Global, we bring the future to you.
            </p>
          </motion.div>
        </div>

        {/* Blog Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {blogs.map((blog, index) => (
            <motion.div 
              key={index}
              className="bg-gray-800 rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition duration-300"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img src={blog.image} alt={blog.title} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h2 className="text-2xl font-semibold text-amber-500">{blog.title}</h2>
                <p className="text-gray-300 mt-2">{blog.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Categories Section */}
        <div className="max-w-6xl mx-auto mt-16">
          <h2 className="text-3xl font-semibold text-amber-500 text-center">Categories</h2>
          <div className="flex flex-wrap justify-center gap-4 mt-6">
            {categories.map((category, index) => (
              <motion.div
                key={index}
                className="bg-gray-700 text-gray-200 px-4 py-2 rounded-full cursor-pointer hover:bg-amber-500 transition duration-300"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                {category}
              </motion.div>
            ))}
          </div>
        </div>

        {/* Testimonials Section */}
        <div className="max-w-6xl mx-auto mt-20 bg-gray-800 p-10 rounded-lg shadow-lg text-center">
          <h2 className="text-3xl font-semibold text-amber-500">What Our Clients Say</h2>
          <motion.p 
            className="text-gray-300 mt-4 italic"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            "JCS Global has transformed the way we handle automation and security. Their expertise in IoT solutions is unmatched!"
          </motion.p>
          <p className="text-gray-400 mt-2">— Alex Johnson, Tech Enthusiast</p>
        </div>
      </div>
      <Footer1 />
    </div>
  );
}
